import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class SharedDataOfUserAttendanceService {
  private rowDataSubject = new BehaviorSubject<any>(null);
  rowData$ = this.rowDataSubject.asObservable();

  setRowData(data: any) {
    this.rowDataSubject.next(data);
  }

  getRowData() {
    return this.rowDataSubject.value;
  }
}
